import { render, staticRenderFns } from "./MainReport.vue?vue&type=template&id=36f9f224&"
import script from "./MainReport.vue?vue&type=script&lang=js&"
export * from "./MainReport.vue?vue&type=script&lang=js&"
import style0 from "./MainReport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MainReport.vue"
export default component.exports